import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

const footerLinks = {
  explore: [
    { label: '热门推荐', href: '/' },
    { label: '最新上线', href: '/' },
    { label: '高分榜单', href: '/' },
    { label: '随机发现', href: '/' },
  ],
  categories: categories.slice(0, 5).map(c => ({
    label: c.name,
    href: `/category/${c.slug}`,
  })),
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌故事', href: '/about' },
    { label: '用户口碑', href: '/about' },
    { label: '联系我们', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-white text-lg"></i>
              </div>
              <span className="text-lg font-heading text-white whitespace-nowrap">91视频网站</span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              高清视频在线观看平台，海量影视综艺动漫纪录片免费播放，畅享极致观影体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 transition-colors duration-200" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速入口</h4>
            <ul className="space-y-2.5">
              {footerLinks.explore.map(link => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">视频分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map(link => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关于</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map(link => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-foreground-400 hover:text-white transition-colors duration-200">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; 2026 91视频网站 版权所有 | 高清视频在线观看平台
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <a href="#" className="hover:text-white transition-colors">用户协议</a>
              <a href="#" className="hover:text-white transition-colors">隐私政策</a>
              <a href="#" className="hover:text-white transition-colors">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}